import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { SubmitButton, CancelButton } from "../../shared";

export function RequestReportModal({
  onCancel,
  onSubmit,
  isSubmitting = false,
  agents = [],
  reportTypes = [],
  isLoadingReportTypes = false,
}) {
  const [reportId, setReportId] = useState("");
  const [fileType, setFileType] = useState("");
  const [agentKey, setAgentKey] = useState("all");
  const [createSeparateFiles, setCreateSeparateFiles] = useState(false);

  const canSubmit =
    reportId && fileType && !isSubmitting && !isLoadingReportTypes;

  const handleSubmit = () => {
    if (!canSubmit || !onSubmit) return;
    onSubmit({
      reportId,
      fileType,
      agentKey,
      CreateSeparateFiles: agentKey === "all" && createSeparateFiles,
    });
  };

  return (
    <Modal show onHide={onCancel} centered className="commission-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">Request Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label className="field-label">Report Type</Form.Label>
          <Form.Select
            value={reportId}
            onChange={(e) => setReportId(e.target.value)}
            aria-label="Select report type"
            autoFocus
            disabled={isLoadingReportTypes || reportTypes.length === 0}
          >
            <option value="">
              {isLoadingReportTypes
                ? "Loading report types..."
                : reportTypes.length === 0
                  ? "No report types available"
                  : "Select report type"}
            </option>
            {reportTypes.map((reportType) => (
              <option key={reportType.key} value={reportType.value}>
                {reportType.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group>
          <Form.Label className="field-label">File Type</Form.Label>
          <Form.Select
            value={fileType}
            onChange={(e) => setFileType(e.target.value)}
            aria-label="Select file type"
          >
            <option value="">Select file type</option>
            <option value="pdf">pdf</option>
            <option value="xlsx">xlsx</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="field-label">Agent</Form.Label>
          <Form.Select
            value={agentKey}
            onChange={(e) => setAgentKey(e.target.value)}
            aria-label="Select agent"
          >
            <option value="all">All</option>
            {agents.map((agent) => (
              <option key={agent.key} value={agent.key}>
                {agent.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {agentKey === "all" && (
          <Form.Check
            type="checkbox"
            label={
              <span className="fw-normal">Create a Separate File Per Agent</span>
            }
            checked={createSeparateFiles}
            onChange={(e) => setCreateSeparateFiles(e.target.checked)}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={onCancel} disabled={isSubmitting} />
        <SubmitButton
          text="Submit"
          color="blue"
          disabled={!canSubmit}
          isSubmitting={isSubmitting}
          onClick={handleSubmit}
        />
      </Modal.Footer>
    </Modal>
  );
}
